import Navbar from "./Navbar";
import { Outlet } from "react-router-dom";
import "../styles/App.css";

export default function AppLayout({ session, open, setopen, ref}) {

  return (
    <div className="hidescroll formatting">
      <Navbar session={session} setopen={setopen} open={open}/>
      <div className={`pagecontent ${open}`} ref={ref}>
        <Outlet />
      </div>
    </div>
  );
}